// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-status-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

/* Common grid filters styles */
.jobs-grid-filters,
.project-grid-filters,
.task-grid-filters,
.help-needed-grid-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
}

.jobs-grid-filters,
.task-grid-filters {
  gap: 20px;
}

.project-grid-filters,
.help-needed-grid-filters {
  gap: 12px;
}

.status-cell {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-align: center;
  background-color: var(--status-color);
  display: block;
  text-align: left;
}

.cell-cicImage {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.image-cell-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.cell-image-preview {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.cell-image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
  border-radius: 4px;
  font-size: 10px;
  color: #888;
  text-align: center;
}

.cell-image-placeholder {
  display: flex;
  border-radius: 4px;
  font-size: 10px;
  color: #888;
}
.cell-image-placeholder i {
  font-size: 24px;
  color: inherit;
}

.artwork-status-container {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
}

.artwork-status-tag {
  background-color: white !important;
  color: gray !important;
  border: 1px solid !important;
  padding: 0.15rem 0.4rem !important;
  margin: 2px 0 !important;
  cursor: pointer !important;
}

.task_link {
  text-decoration: none;
}
.task_link:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/ModuleGrids/ModuleGrids.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AAAF;;AAEA,+BAAA;AACA;;;;EAIE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,SAAA;AACF;;AAEA;;EAEE,SAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAEF;AAAE;EACE,eAAA;EACA,cAAA;AAEJ;;AACA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;EACA,0BAAA;AAEF;;AACA;EACE,qBAAA;AAEF;AAAE;EACE,0BAAA;AAEJ","sourcesContent":["// Center only job grid status column\n.job-status-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n/* Common grid filters styles */\n.jobs-grid-filters,\n.project-grid-filters,\n.task-grid-filters,\n.help-needed-grid-filters {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 20px;\n}\n\n.jobs-grid-filters,\n.task-grid-filters {\n  gap: 20px;\n}\n\n.project-grid-filters,\n.help-needed-grid-filters {\n  gap: 12px;\n}\n//Cell template for status column in all grids\n.status-cell {\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  text-align: center;\n  background-color: var(--status-color);\n  display: block;\n  text-align: left;\n}\n\n.cell-cicImage {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n  }\n\n.image-cell-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.cell-image-preview {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n.cell-image-error {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f4f4f4;\n  border-radius: 4px;\n  font-size: 10px;\n  color: #888;\n  text-align: center;\n}\n\n.cell-image-placeholder {\n  display: flex;\n  border-radius: 4px;\n  font-size: 10px;\n  color: #888;\n\n  i {\n    font-size: 24px;\n    color: inherit;\n  }\n}\n.artwork-status-container {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.artwork-status-tag {\n  background-color: white !important;\n  color: gray !important;\n  border: 1px solid !important;\n  padding: 0.15rem 0.4rem !important;\n  margin: 2px 0 !important;\n  cursor: pointer !important;\n}\n\n.task_link {\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
